// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"13":"6f823b23","106":"5534ea1b","195":"5ade2021","206":"02b05991","272":"fa4345e0","385":"075e1bec","464":"b4ac0f26","657":"6b5eba64","731":"adb92940","838":"fd1a9267","886":"f6541f70","979":"a3b3559d","985":"cc130214"}[chunkId] + ".js";
};